import classnames from "classnames";
import React from "react";

import styles from "../FormField.module.scss";

export interface IEmailFormFieldProps {
  id?: string;
  error?: string;
  name?: string;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const EmailFormField: React.FC<IEmailFormFieldProps> = ({
  registerField,
  error,
  isFocused,
  ...props
}) => {
  // const maskEmail = (e) => {
  //   const mailformat =
  //     /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  //   if (e.target.value.match(mailformat)) {
  //     return setErr(false);
  //   } else {
  //     return error;
  //   }
  // };

  return (
    <input
      {...registerField}
      className={classnames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      {...props}
    />
  );
};
